const routes = require(`./router-${process.env.VUE_APP_NAME}`);

const routesList = routes.concat([
	
	{
		path: "/no-auth",
		component: () => import('@/pages/error/no-auth'),
		meta:{
			noAuth:true
		},
		hidden: true
	},
	
	{
		path: "*",
		component: () => import('@/pages/error/404'),
		meta:{
			noAuth:true
		},
		hidden: true
	}
]);

module.exports = routesList;
